export var Events;
(function (Events) {
    let Bus;
    (function (Bus) {
        Bus["HTTP"] = "http";
        Bus["APP"] = "application";
    })(Bus = Events.Bus || (Events.Bus = {}));
    Events.questionIntermediateChangeEvent = (field) => `intermediate-change-${field}`;
    Events.Type = {
        LessThanTwoMonthsLayup: 'less-than-two-months-layup',
        RefreshSubQuestions: 'refresh-sub-questions',
        RefreshDisplayedVals: 'refresh-displayed-vals',
        Error: 'error',
        LoginSuccess: 'login-success',
        Refresh: 'refresh',
        QuestionUpdate: 'question-update',
        ProgressChanged: 'progress-changed',
        SectionCompleted: 'section-completed',
        QuestionViewConditionChange: 'question-view-condition-changed',
        SectionChanged: 'questionnaire-section-chage',
        KeyboardStateChanged: 'keyboard-state-changed',
        Swipe: 'swipe',
        SigndocStatusChange: 'signdoc-status-change',
        TooltipToggled: 'tooltip-toggled',
        CloseAllTooltips: 'close-all-tooltips',
        // RequestFirstBlock: 'request-first-block',
        RefreshHeader: 'refresh-header',
        Back: 'request-back',
        PopupClose: 'request-popup-close',
        PopupClosed: 'popup-close-button',
        ErrorPopupClosed: 'error-popup-close-button',
        PopupNext: 'popup-next-button',
        ListRemoteUpdated: 'list-remote-updated',
        Validate: 'validate',
        AllQuestionsValid: 'all-questions-valid',
        NotAllQuestionsValid: 'not-all-questions-valid',
        AlertBankAccountNumber: 'alert-bank-account',
        MaxLengthAccountName: 'max-account-name',
        SingleQuestionInvalid: 'single-question-invalid',
        SingleQuestionValid: 'single-question-valid',
        AddQuestionError: 'add-question-error',
        BillingToken: 'billing-token',
        UnlockScreen: 'unlock-screen',
        SubmitBillingForm: 'submit-billing-form',
        SaveWebSectionTracking: 'save-web-section-tracking',
        NotifyTracking: 'notify-tracking',
        CreditBillingResponse: 'credit-billing-response',
        Congratulations: 'congratulations',
        CustomerStatusChange: 'customer-status-change',
        FeedbackSection: 'feedback-section',
        GoToWebsite: 'go-to-website',
        QuestionnaireIdSet: 'questionnaire-id-set',
        ValuesNotValid: 'values-not-valid',
        BankAccountName: 'bank-account-name',
        ReturnBackToCustomerTask: 'return-back-to-customer-task',
        ReturnBackToCustomerTaskResponse: 'return-back-to-customer-task-response',
        OpenCallBackForm: 'open-call-back-form',
        CloseCallBackForm: 'close-call-back-form',
        NavigatingOutOfNewLp: 'navigating-out-of-new-lp',
        NewLpValidationErr: 'new-lp-validation-err',
        CustomLpLoad: 'custom-lp-load',
        RemoveFunnelHiding: 'remove-funnel-hiding',
        CallAnAgentRequest: 'call-an-agent-request',
        ShowToast: 'show-toast',
        ImagePreviewModeChange: 'image-preview-mode-change',
        ShowToastWithBackdrop: 'show-toast-with-backdrop',
        OpenChatRequest: 'open-chat-request',
        ShowPopup: 'show-popup',
        ShowPopupOnEvent: 'show-popup-on-event',
        SetValuePopupOpen: 'set-value-popup-open',
        Logout: 'logout',
        ExitPopupClose: 'exit-popup-close',
        SetStormStates: 'set-storm-states',
        LogExitOnBackgroundSend: 'log-exit-on-background-send',
        ChangePhoneNumber: 'change-phone-number',
        FocusOnPhoneElement: 'focus-on-phone-element',
        LogPopupButtonClick: 'log-popup-button-click',
        StartInsuranceToday: 'start-insurance-today',
        TotalYearlyAmount: 'total-yearly-amount',
        ClickNext: 'click-next',
        OcrProcessingCompleted: 'ocr-processing-completed',
        OcrUserResetOcrValues: 'ocr-user-reset-ocr-values',
    };
})(Events || (Events = {}));
//# sourceMappingURL=app-events.js.map